import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../../styles/Form.css";
import logo from "../../images/logo.png";

const ListAllConsentHistory = () => {
  const [history, setHistory] = useState([]);
  const [signdates, setSigndates] = useState({});
  const { id: userId } = useParams();
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    console.log({ userId }); // ✅ Add this line

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/work-history/working/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setHistory(res.data);
      } catch (err) {
        console.error("Error fetching work history:", err);
      }
    };

    const fetchTaskStatus = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/usertasks/status/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setSigndates(res.data.signdates || {});
      } catch (err) {
        console.error("Error fetching task status:", err);
      }
    };

    if (userId) {
      fetchData();
      fetchTaskStatus();
    }
  }, [API_BASE, userId]);

  const handleCancel = () => {
    if (isAdmin) {
      navigate(`/userhome/${userId}`);
    } else {
      navigate("/userhome");
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center pt-3">
        <div className="d-flex align-items-center">
          <span className="me-2 text-danger"></span>
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Consent to Safety and Performance History
          </span>
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Return
        </button>
      </div>

      <div
        className="form-wrapper my-4"
        style={{ fontSize: "15px", lineHeight: "1.6" }}
      >
        <div className="row align-items-center mb-4">
          <div className="col-3 text-start">
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <div className="col-6 text-center">
            <h2 className="m-0">Consent to Safety and Performance History</h2>
          </div>
          <div className="col-3 text-end">
            <strong>New-Way Trucking Ltd</strong>
            <br />
            7725 48 St. SE, Calgary
            <br />
            Alberta, Canada T2C 2V3
          </div>
        </div>

        <table className="table table-bordered table-striped mt-4">
          <thead className="table-light">
            <tr>
              <th>Employer/Contract</th>
              <th>Date Created</th>
              <th>Created By</th>
              <th>Date Completed</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(history) ? (
              history.map((item) => (
                <tr
                  key={item.wh_id}
                  onClick={() => navigate(`/consent/${userId}/${item.wh_id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{item.wh_name}</td>
                  <td>{item.wh_created_date?.slice(0, 10)}</td>
                  <td>{item.created_by}</td>
                  <td>
                    {signdates[`consent_history_${item.wh_id}`]?.slice(0, 10) ||
                      "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No history found or error loading data.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListAllConsentHistory;
